<template>
  <div class="cmd-news-item-not-found">
    <a href="/News" class="cmd-news-item-not-found__back-link">
      <svg-icon icon="straight-arrows/right" viewBox="0 0 16 16"/>
      <span>{{ $res.Views.News_BackToNewsList }}</span>
    </a>
    <empty-results :error-description="$res.General.NewsItemNotFound"/>
  </div>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import EmptyResults from "@/common/EmptyResultsComponentDesktop.vue";

export default {
  components: {
    EmptyResults,
    SvgIcon
  },
  props: {
    viewModel: Object,
  },
}
</script>

<style lang="scss" scoped>
.cmd-news-item-not-found {
  display: flex;
  flex-direction: column;
}

.cmd-news-item-not-found__back-link {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  width: fit-content;
  
  svg {
    transform: rotate(180deg);
  }
}
</style>